import React, { Fragment, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import CategoryAndFolderSelector from './CategoryAndFolderSelector';
import { getDocumentUrl, getExternalResourceUrl } from '../../utilities/urlHelper';
import { getIndexResourceId } from '../../utilities/schemaUtility';
import { ICON, RESOURCE_TYPE } from '../../utilities/CONSTANTS';

const getIconForResource = (resource) => {
    if (resource.resource_type === RESOURCE_TYPE.TETTRA_PDF) {
        return ICON.PDF_DOCUMENT;
    } if (resource.icon) {
        return resource.icon;
    }

    return ICON.LINK;
};

const MoveResourceModal = ({ resource, closeModal }) => {
    const onMouseDownModal = useCallback(({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            closeModal();
        }
    }, [closeModal]);

    const iconUrl = getIconForResource(resource);
    const isDocumentResource = resource.resource_type === RESOURCE_TYPE.TETTRA_PDF;
    const resourceId = getIndexResourceId(resource.id);
    const formUrl = isDocumentResource ? getDocumentUrl(resourceId) : getExternalResourceUrl(resourceId);
    const moveLabel = isDocumentResource ? 'Move document' : 'Move link';

    return (
        <div className="react-modal open move-page-modal" onMouseDown={onMouseDownModal}>
            <div className="modal-content">
                <h2>{moveLabel}</h2>
                <div className="mt2 mb2 flex">
                    <img className="flex-none mr1" height="22" src={iconUrl} alt="" />
                    <div className="flex-auto">
                        <span className="h4">{resource.title}</span>
                    </div>
                </div>
                <form action={formUrl} method="POST">
                    <input name="_token" type="hidden" value={window.csrfToken} />
                    <input name="_method" type="hidden" value="put" />
                    <div className="mt2 mb2">
                        <CategoryAndFolderSelector
                            initialCategoryId={resource.category_id}
                            initialFolderId={resource.folder_id}
                        />
                    </div>
                    <div className="right-align">
                        <span className="react-modal-close btn-secondary mr1" onMouseDown={closeModal}>Close</span>
                        <input type="submit" className="btn btn-primary" value="Move" />
                    </div>
                </form>
            </div>
        </div>
    );
};

const MoveResourceWrapper = ({ resource }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Fragment>
            <span className="dropdown-option move-modal-link link" onMouseDown={() => setShowModal(true)}>Move</span>
            { showModal && createPortal(<MoveResourceModal resource={resource} closeModal={() => setShowModal(false)} />, document.body) }
        </Fragment>

    );
};

export default MoveResourceWrapper;
